<div class="heading">
    <div class="button-wrapper">
        <button class="btn hvr-grow has-margin-right" (click)="exportFinanceMarginReport()"> 
            Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>
    </div>
</div>
<section class="main-content wrapper content-padding scroll-delivery">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
        <form class="table-row-container row first-row filter" [formGroup]="financeFeesFilterForm" (ngSubmit)="filter()" *ngIf="financeFeesFilterForm">
            <div class="item center data-col-">
                <h4 class="title">STATO</h4>
                <span class="data">
                <select formControlName="Delivery.status">
                    <option value="">Tutti</option>
                    <option *ngFor="let dSActive of deliveryStatusAux['forFinance']" [value]="dSActive">
                        {{deliveryStatusAux.ln('it', dSActive)}}
                    </option>
                </select>
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
                    VENDITA
                </h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
                </span>
            </div>

            <div class="item center data-col-5">
                <h4 class="title">PLATFORM</h4>
                <span class="data">
                <select formControlName="Sale.platform">
                    <option value="">Tutti</option>
                    <option value="shopifysale">Deluxy Vendita</option>
                    <option value="cakesales">Cakes Vendita</option>
                    <option value="flowerssales">Flowers Vendita</option>
                    <option value="deluxyexperiencesales">Deluxy Experience Vendita</option>
                    <option value="deluxydotcomsales">Deluxy Dot Com Vendita</option>
                </select>
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.id')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.id')"></i>
                    ID
                </h4>
                <span class="data">
                    <input type="number" formControlName="Delivery.id" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
                    DATA
                </h4>
                <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
                </span>
                <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
                </span>
            </div>

            <div  class="item center data-col-">
                <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
                    ORARIO
                </h4>
                <span class="data">
                    <div class="date">Da: </div>
                    <input class="date" type="time" formControlName="Delivery.fromTime">
                </span>
                <span class="data">
                    <div class="date">A: </div>
                    <input class="date" type="time" formControlName="Delivery.toTime">
                </span>
            </div>

            <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                    PARTNER
                </h4>
                <span class="data">
                    <input type="text" formControlName="Partner.businessName" >
                </span>
            </div>

            <div class="item data-col-" >
                <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
                    VALET
                </h4>
                <span class="data">
                    <input type="text" formControlName="UserExpert.surname" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
                    INDIRIZZO
                </h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.address" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title" (click)="navigateOrder(['Delivery.pickUpAddress'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpAddress'])"></i>
                    INDIRIZZO DI RITIRO
                </h4>
                <span class="data">
                    <input type="text" formControlName="Delivery.pickUpAddress">
                </span>
            </div>

            <div class="item pickUpTime data-col- ">
                <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
                    <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
                    ORA RITIRO
                </h4>
                <span class="data">
                    <div class="date"></div>
                    <input class="date" type="time" formControlName="Delivery.pickUpTime">
                </span>
            </div>

            <div class="item data-col-5">
                <h4 class="title">TIPO SERVIZIO</h4>
                <span class="data">
                    <select formControlName="Delivery.serviceType">
                        <option value="">Tutti</option>
                        <option value="sales">Servizi Vendita</option>
                        <option value="hourlyrate">Servizi a Ora</option>
                        <option value="fixedprice">Servizi a Prezzo Fisso</option>
                    </select>
                </span>
            </div>

            <div class="item center data-col-30" >
                <h4 class="title">DA FATTURARE</h4>
                <span class="data">
                <select formControlName="Delivery.billable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
                </span>
            </div>

            <div class="item center data-col-30" >
                <h4 class="title">DA PAGARE</h4>
                <span class="data">
                <select formControlName="Delivery.payable" style="width: 120px;">
                    <option value="">Tutti</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    PREZZO
                </h4>
                <span class="data">
                    <select style="width: 40px;" formControlName="Delivery.price.operator">
                        <option value="equal">=</option>
                        <option value="lessThan"><</option>
                        <option value="moreThan">></option>
                        <option value="moreThanOrEqual">>=</option>
                        <option value="lessThanOrEqual"><=</option>
                    </select>
                    <input type="number" formControlName="Delivery.price" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    +/- PREZZO
                </h4>
                <span class="data">
                    <select style="width: 40px;" formControlName="Delivery.additionalPrice.operator">
                        <option value="equal">=</option>
                        <option value="lessThan"><</option>
                        <option value="moreThan">></option>
                        <option value="moreThanOrEqual">>=</option>
                        <option value="lessThanOrEqual"><=</option>
                    </select>
                    <input type="number" formControlName="Delivery.additionalPrice" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    VALET SALARIO
                </h4>
                <span class="data">
                    <select style="width: 40px;" formControlName="Delivery.expertSalary.operator">
                        <option value="equal">=</option>
                        <option value="lessThan"><</option>
                        <option value="moreThan">></option>
                        <option value="moreThanOrEqual">>=</option>
                        <option value="lessThanOrEqual"><=</option>
                    </select>
                    <input type="number" formControlName="Delivery.expertSalary" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    +/- PREZZO STIPENDI
                </h4>
                <span class="data">
                    <select style="width: 40px;" formControlName="Delivery.valetAdditionalPrice.operator">
                        <option value="equal">=</option>
                        <option value="lessThan"><</option>
                        <option value="moreThan">></option>
                        <option value="moreThanOrEqual">>=</option>
                        <option value="lessThanOrEqual"><=</option>
                    </select>
                    <input type="number" formControlName="Delivery.valetAdditionalPrice" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    MARGINE TOTALE
                </h4>
                <span class="data">
                    <select [(ngModel)]="filters.margineTotale.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;"  [(ngModel)]="filters.margineTotale.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item data-col-">
                <h4 class="title">
                    <i class="sort-icon fas fa-sort"></i>
                    MARGINE TOTALE %
                </h4>
                <span class="data">`
                    <select [(ngModel)]="filters.margineTotalePercentage.operator" [ngModelOptions]="{standalone: true}" (change)="applyDomFilters()" style="width: 40px;">
                        <option value="=">=</option>    
                        <option value="<"><</option>
                        <option value=">">></option>
                        <option value=">=">>=</option>
                        <option value="<="><=</option>
                    </select>
                    <input type="number" style="width: 100px;" [(ngModel)]="filters.margineTotalePercentage.value" [ngModelOptions]="{standalone: true}" (input)="applyDomFilters()" min="1000" max="10000" >
                </span>
            </div>

            <div class="item nowrap">
                <h4 class="title hide-on-mobile">AZIONI</h4>
                <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                    RICERCA <i class="fas fa-search"></i></button>
                    <br/>
                <button class="btn vertical align-items-center" (click)="resetFilter();">
                    RESET <i class="fas fa-times-circle"></i></button>
                </span>
            </div>

        </form>

        <div class="table-row-container row" *ngFor="let delivery of flattenedDeliveries" [ngClass]="{'parent-total-row': delivery?.isTotalRow}">

            <ng-container *ngIf="delivery?.isTotalRow">
                <div class="item left-space data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">STATO :</h4>
                        <span class="status-service-image">
                            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                            <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                            <span class="dataGesture">
                                <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                            </span>
                            </a>
                        </span>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VENDITA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ 
                                (
                                    delivery?.orderId && delivery?.externalOrderSource
                                ) ? 'M' + delivery.orderId
                                    : (
                                        delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? (delivery.orderId | saleName: delivery.shop)
                                    : (
                                        delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? delivery.ddtNumber
                                        : '---'
                            }}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left">
                    <h4 class="title table-title">PLATFORM:</h4>
                    <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                        {{ delivery?.shopifySale ? delivery?.shopifySale?.platform?.toUpperCase() : "N/A" }}
                    </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{delivery.id}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title dataGesture">DATA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ORARIO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() != 'hourlyrate' " >
                            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
                        </a>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() === 'hourlyrate' " >
                            {{formatTimeShow(delivery.startTime, delivery.endTime)}}
                        </a>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="!delivery?.service" >
                            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{delivery.partner?.businessName}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALET :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left tick" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INDIRIZZO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{delivery?.pickUpAddress || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item data-col- pickUpTime">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ORA RITIRO :</h4>
                        <a  [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ delivery?.pickUpTime || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item left-space data-col-5">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">TIPO SERVIZIO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ delivery?.serviceType | serviceName }}
                        </a>
                    </span>
                </div>

                <div class="item center left-space data-col-30">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">DA FATTURARE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{
                                delivery?.billable ? "Yes" : "No"
                            }}
                        </a>
                    </span>
                </div>

                <div class="item center left-space data-col-30">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">DA PAGARE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{
                                delivery?.payable ? "Yes" : "No"
                            }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentPartnerPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">+/- PREZZO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentPartnerAdditionalPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALET SALARIO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentExpertPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">+/- PREZZO STIPENDI:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentExpertAdditionalPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentMargineTotale | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                            {{ showTotalOfParentRow(delivery)?.parentMargineTotalePercentage }}%
                        </a>
                    </span>
                </div>
            </ng-container>

            <ng-container *ngIf="!delivery?.isTotalRow">
                <div class="item left-space data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">STATO :</h4>
                        <span class="status-service-image">
                            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
                            <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
                            <span class="dataGesture">
                                <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                            </span>
                            </a>
                        </span>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VENDITA:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ 
                                (
                                    delivery?.orderId && delivery?.externalOrderSource
                                ) ? 'M' + delivery.orderId
                                    : (
                                        delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? (delivery.orderId | saleName: delivery.shop)
                                    : (
                                        delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource
                                    ) ? delivery.ddtNumber
                                        : '---'
                            }}
                        </a>
                    </span>
                </div>
                
                <div class="item data-col-">
                    <span class="data-row-left">
                    <h4 class="title table-title">PLATFORM:</h4>
                    <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
                        {{ delivery?.shopifySale ? delivery?.shopifySale?.platform?.toUpperCase() : "N/A" }}
                    </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ID :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery.id}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title dataGesture">DATA :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ORARIO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() != 'hourlyrate' " [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
                        </a>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() === 'hourlyrate' " [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{formatTimeShow(delivery.startTime, delivery.endTime)}}
                        </a>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="!delivery?.service" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PARTNER :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery.partner?.businessName}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALET :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left tick" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INDIRIZZO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{delivery?.pickUpAddress || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item data-col- pickUpTime" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">ORA RITIRO :</h4>
                        <a  [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ delivery?.pickUpTime || "---"}}
                        </a>
                    </span>
                </div>

                <div class="item left-space data-col-5" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">TIPO SERVIZIO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ delivery?.serviceType | serviceName }}
                        </a>
                    </span>
                </div>

                <div class="item center left-space data-col-30" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">DA FATTURARE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{
                                delivery?.billable ? "Yes" : "No"
                            }}
                        </a>
                    </span>
                </div>

                <div class="item center left-space data-col-30" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((groups.includes('admin') && delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title">DA PAGARE :</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{
                                delivery?.payable ? "Yes" : "No"
                            }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">PREZZO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.partnerPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">+/- PREZZO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.partnerAdditionalPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">VALET SALARIO:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.expertPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">+/- PREZZO STIPENDI:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.expertAdditionalPrice | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.margineTotale | currency:'EUR' }}
                        </a>
                    </span>
                </div>

                <div class="item center data-col-" [ngClass]="{'sub-parent-row': commanFunctionForValues(delivery)?.isMultiple}">
                    <span class="data-row-left" [ngClass]="{'data-id': ((delivery?.expert && delivery?.expert?.isTeamLeader))}">
                        <h4 class="title table-title">MARGINE TOTALE %:</h4>
                        <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="{'text-danger': commanFunctionForValues(delivery)?.margineTotale <= 0}">
                            {{ commanFunctionForValues(delivery)?.margineTotalePercentage }}%
                        </a>
                    </span>
                </div>
            </ng-container>

        </div>

        <div class="table-row-container row total-row" *ngIf="flattenedDeliveries.length">
            <div class="item data-col-5">
                <span class="data-row-left">
                    <a >
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>
          
            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>

            <div class="item data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>
          
            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>Totale</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues.totalPartnerPrice | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues.totalPartnerAdditionalPrice | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues.totalExpertPrice | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues.totalExpertAdditionalPrice | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues.totalMargineTotale | currency:'EUR' }}</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong>{{ totalValues?.totalMarginePercentage?.toFixed(2) }} %</strong>
                    </a>
                </span>
            </div>

            <div class="item center data-col-">
                <span class="data-row-left">
                    <a>
                        <strong></strong>
                    </a>
                </span>
            </div>
          
        </div>
    </div>
</section>